import { ParametrosWSBase, DestinoConexion } from "../ParametrosWSBase";
import { EncabezadoRespuestaInterna } from "../EncabezadoRespuestaInterna";

export function ModificarPasswordOKTA_Parametros(datos: any) {
  var par: ParametrosWSBase = {
    nombreProceso: "cambiarContrasena",
    rutaEndPoint: "/EnterpriseServices/Okta/Usuario/cambiarContrasena",
    sistemaOrigen: "AppSky",
    AGREGAR_ENCABEZADO: true,
    DESTINO_SERVICIO: DestinoConexion.Proxy,
    parametros: { ...datos },
        cRC:null
  };

  return par;
}

export function builtModificarPasswordOKTAInput(
  Correo: string,
  ContrasenaNuevo: string,
  ContrasenaAnterior: string

) {
  var retorno: ModificarPasswordOKTA_Entrada =
    builtModificarPasswordOKTA_Entrada(
      builtUsuario(Correo, ContrasenaNuevo, ContrasenaAnterior)
    );

  return retorno;
}

//ENTRADA
export interface ModificarPasswordOKTA_Entrada {
  Usuario: Usuario;
}

export function builtModificarPasswordOKTA_Entrada(
  l_Usuario: Usuario
) {
  var retorno: ModificarPasswordOKTA_Entrada = {
    Usuario:
      l_Usuario,
  };

  return retorno;
}

export interface Usuario {
  Correo: string;
  Credenciales: any;

}

export function builtUsuario(
  Correo: string,
  ContrasenaNuevo: string,
  ContrasenaAnterior: string



) {
  var retorno: Usuario = {
    Correo: Correo,
    Credenciales: { ContrasenaNuevo, ContrasenaAnterior }


  };

  return retorno;
}



export type ModificarPasswordOKTA_Respuesta = EncabezadoRespuestaInterna;